import {
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons';
import React, { FC, useMemo, useState } from 'react';
import styles from '../../Style/LegendView.module.scss';
import LegendScaleSlider from './LegendScaleSlider';
import { debounce } from 'underscore';
import useLegendStore from "../../../../../store/legendStore";

interface Props {
  result: any,
  setLegendStartEndValues : Function
}

export const LegendView: FC<Props> = ({ result, setLegendStartEndValues }) => {
  const legend = useLegendStore(state => state.legend);
  const [showLegend, setShowLegend] = useState<boolean>(true);
  const [startValue, setStartValue] = useState(0);
  const [endValue, setEndValue] = useState(0);

  const { legendMinValue, legendMaxValue } = useMemo(() => {
    if (result?.featureCollection?.features?.length > 0) {
      setStartValue(result?.minDepth)
      setEndValue(result?.maxDepth)
    }
    return { legendMinValue: -9999, legendMaxValue: 9999 }
  }, [result?.minDepth, result?.maxDepth]);

  const onLegendStartEndChanged = debounce((min: number, max: number) => {
    setLegendStartEndValues([min, max]);
  }, 50);

  const values = legend?.title.toLowerCase().includes('bathymetry')
    ? legend.values
    : legend?.values.map((item) => item).reverse();

  return (
    <div className={`${styles.root}`}>
      <div className={styles.header} onClick={() => setShowLegend(!showLegend)}>
        <div className={styles.title}>{legend?.name}</div>
        {showLegend ? (
          <UpOutlined className={`${styles.icon}`} />
        ) : (
          <DownOutlined className={`${styles.icon}`} />
        )}
      </div>
      {showLegend && (
        <div className={styles.content}>
          <div className={styles.contentTitle}>{'[' + legend?.unit + ']'}</div>
          <div className={styles.contentValuesContainer}>
            {values?.map((v, i) => (
              <div key={i} className={styles.contentValueItem}>
                <div className={styles.number}>{v.value.toFixed(2)}</div>
                <div
                  style={{ backgroundColor: v.color }}
                  className={styles.colorBlock}
                ></div>
              </div>
            ))}
          </div>
          {legendMinValue && legendMaxValue &&
              <LegendScaleSlider
                endValue={endValue}
                startValue={startValue}
                setEndValue={setEndValue}
                setStartValue={setStartValue}
                showLegendScale={true}
                initialLegendValue={{ legendMinValue: result?.minDepth ?? -9999, legendMaxValue: result?.maxDepth ?? 9999 }}
                legendMinMaxValues={{ legendMinValue, legendMaxValue }}
                onLegendStartEndChanged={onLegendStartEndChanged}
              />
            }
        </div>
      )}
    </div>
  );
}
